import React from 'react';
import Box from '@mui/system/Box';
import Typography from '@mui/material/Typography';
import { CheckCircle } from '@mui/icons-material';
import { COLORS } from '@styles';

const makeStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    alignItems: 'center',
    width: '100%',
  },
  iconContainer: {
    width: '187px',
    height: '187px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    alignItems: 'center',
    width: '390px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'flex-start',
    textAlign: 'center',
    color: '#1E202C',
    width: '390px',
  },
  title: {
    fontFamily: 'Urbanist',
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: '40px',
    color: '#1E202C',
    width: '100%',
  },
  description: {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#1E202C',
    width: '100%',
  },
});

export function SuccessStep() {
  const sx = makeStyles();

  return (
    <Box sx={sx.container}>
      <Box sx={sx.iconContainer}>
        <CheckCircle
          sx={{
            fontSize: '187px',
            color: COLORS.POSITIVE_NEUTRAL,
          }}
        />
      </Box>
      <Box sx={sx.contentContainer}>
        <Box sx={sx.textContainer}>
          <Typography sx={sx.title}>You are protected and your device was verified!</Typography>
          <Typography sx={sx.description}>
            Your account is now secured with 2-Factor Authentication. Please continue to the next
            step to start setting up your personal and family information.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
